module.exports = __webpack_public_path__ + "icon-192x192.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/icon-192x192.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/icon-192x192.png
// module chunks = 7